import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios'; // Import Axios
import config from '../config'; // Adjust the path as necessary
import '../components/CompleteProfile.css';
const CompleteProfile = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { userData } = location.state || {};

    const [company, setCompany] = useState('');
    const [employeeCode, setEmployeeCode] = useState('');
    const [mobile, setMobile] = useState('');

    const handleSubmit = async (e) => {


        console.log('Location state:', location.state);

        e.preventDefault();

        // Combine the additional info with existing user data
        const completeUserData = {
            ...location.state.user,
            company,
            employeeCode,
            mobile
        };

        try {
            // Send the complete user data to the backend using Axios

            console.log(completeUserData);
            const apiUrl = config.API_BASE_URL;
            const response = await axios.post(`${apiUrl}/users/completeprofile`, completeUserData, {
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            console.log('Profile completed:', response.data);
            // Save the complete user data
            localStorage.setItem('user', JSON.stringify(response.data));
            if (response.data.token) {
                localStorage.setItem('token', response.data.token);
            }
            // Redirect to dashboard
            navigate('/ticketlist');
        } catch (error) {
            console.error('Error completing profile:', error);
        }
    };

    return (
        <form onSubmit={handleSubmit} className="container mt-4">
            <h2>Complete Your Profile</h2>
            <div className="mb-3">
                <label htmlFor="company" className="form-label">Company:</label>
                <select
                    id="company"
                    className="form-select"
                    value={company}
                    onChange={(e) => setCompany(e.target.value)}
                    required
                >
                    <option value="">Select Company</option>
                    {config.companies.map((company) => (
                        <option key={company.id} value={company.name}>
                            {company.name}
                        </option>
                    ))}
                </select>
            </div>
            <div className="mb-3">
                <label htmlFor="employeeCode" className="form-label">Employee Code:</label>
                <input
                    type="text"
                    id="employeeCode"
                    className="form-control"
                    value={employeeCode}
                    onChange={(e) => setEmployeeCode(e.target.value)}
                    required
                />
            </div>
            <div className="mb-3">
                <label htmlFor="mobile" className="form-label">Mobile Number:</label>
                <input
                    type="tel"
                    id="mobile"
                    className="form-control"
                    value={mobile}
                    onChange={(e) => setMobile(e.target.value)}
                    required
                />
            </div>
            <button type="submit" className="btn btn-primary">Complete Profile</button>
        </form>
    );
};

export default CompleteProfile;